import { slice } from './slice'

const afaCartSummaryActions = {
  ...slice.actions,
}

export default afaCartSummaryActions
